"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Licenses;
var _react = _interopRequireWildcard(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy2"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Log = require("../Log");
var _Context = _interopRequireDefault(require("../../components/LicensingAdminContext/Context"));
var _individuals = _interopRequireDefault(require("./individuals.graphql"));
var _individualsHistory = _interopRequireDefault(require("./individualsHistory.graphql"));
var _groups = _interopRequireDefault(require("./groups.graphql"));
var _groupsHistory = _interopRequireDefault(require("./groupsHistory.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
function Licenses() {
  if (!Fortress.hasAnyAccess(['licensing.admin', 'licensing.licenses'])) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "You do not have permission to access this page"));
  }
  var _useState = (0, _react.useState)('individual'),
    _useState2 = _slicedToArray(_useState, 2),
    showBy = _useState2[0],
    setShowBy = _useState2[1]; // will be "individual" or a group type handle
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHistorical = _useState4[0],
    setIsHistorical = _useState4[1];
  var _useContext = (0, _react.useContext)(_Context["default"]),
    selectedProduct = _useContext.selectedProduct;
  var location = (0, _cccisdReactRouter.useLocation)();
  if (!(selectedProduct !== null && selectedProduct !== void 0 && selectedProduct.productId)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "There are no Licensed Products. Start by\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
      to: location.pathname + '#products'
    }, "creating a new Licensed Product"), " before viewing data on individual licenses."));
  }
  function renderOptions() {
    var groupTypes = Appdefs.pawn.groups.filter(function (g) {
      return !['questproject', 'questorganization'].includes(g.handle);
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].options
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "showBy"
    }, "Show:"), /*#__PURE__*/_react["default"].createElement("select", {
      value: showBy,
      className: "form-control",
      name: "showBy",
      onChange: function onChange(event) {
        return setShowBy(event.target.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: "individual",
      key: "individual"
    }, "Individuals"), groupTypes.map(function (g) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        value: g.handle,
        key: g.handle
      }, g.labelPlural || g.label);
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'form-group ' + _style["default"].pills
    }, /*#__PURE__*/_react["default"].createElement("label", null, "View:"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn ' + (isHistorical ? 'btn-secondary' : 'btn-primary'),
      onClick: function onClick() {
        return setIsHistorical(false);
      }
    }, "Current"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn ' + (isHistorical ? 'btn-primary' : 'btn-secondary'),
      onClick: function onClick() {
        return setIsHistorical(true);
      }
    }, "History"))));
  }
  function renderHistorySummary(extraData) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].historyLegend
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb-2"
    }, /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement("b", null, "Additions"), "* refers to the total number of \"Assign\", \"Create\" and \"Voucher Redeem\" actions.")), /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb-2"
    }, /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement("b", null, "Renewals"), " refers to the total number of \"Renewal\" actions.")), /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb-0"
    }, /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement("b", null, "*"), "Note: Sometimes a single user event can trigger 2 actions. For example, creating a new license using a voucher will record both a \"Create\" action and a \"Voucher Redeem\" action.")))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_style["default"].historySummary, " alert alert-info")
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Total"), /*#__PURE__*/_react["default"].createElement("span", null, "Additions: ", Number.isInteger(extraData.additions) ? extraData.additions : '-'), /*#__PURE__*/_react["default"].createElement("span", null, "Renewals: ", Number.isInteger(extraData.renewals) ? extraData.renewals : '-')));
  }
  function getIndividualCurrentTableProps() {
    var columns = [{
      name: 'status',
      label: 'Status',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- select --',
        options: [{
          label: 'Active',
          value: 'active'
        }, {
          label: 'Expired',
          value: 'expired'
        }]
      },
      render: function render(_ref) {
        var value = _ref.value;
        if (value === 'expired') {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "label label-warning"
          }, "Expired");
        }
        if (value === 'active') {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "label label-success"
          }, "Active");
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "label label-default"
        }, value);
      }
    }, {
      name: 'pawn.user.username',
      label: 'Username',
      filter: true,
      sort: true
    }, {
      name: 'pawn.role.label',
      label: 'Role',
      filter: true,
      sort: true
    }, {
      name: 'pawn.parentGroup.anyGroup.group.label',
      label: 'Group',
      filter: true,
      sort: true
    }, {
      name: 'voucher.code',
      label: 'Voucher',
      filter: true,
      sort: true,
      tooltip: /*#__PURE__*/_react["default"].createElement("div", null, "NOTE: The filter field for this column is intended to search for the code only. Pasting in the full redemption URL will not yield results."),
      render: function render(_ref2) {
        var value = _ref2.value;
        return value ? /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-xs",
          onClick: function onClick() {
            var url = Boilerplate.url("/licensing/voucher/redeem/".concat(value));
            navigator.clipboard.writeText(url);
            (0, _cccisdNotification["default"])('Voucher Redemption URL copied!');
          }
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_copy["default"], null), /*#__PURE__*/_react["default"].createElement("code", null, value))) : '-';
      }
    }, {
      name: 'createdDate',
      label: 'Activated',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'expiresDate',
      label: 'Expires',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }];
    return {
      query: _individuals["default"],
      columns: columns,
      graphqlVariables: {
        productId: selectedProduct.productId
      },
      rowKey: 'licenseId'
    };
  }
  function getIndividualHistoricalTableProps() {
    var actionWhiteList = {
      'ownedLicense:create': true,
      'ownedLicense:delete': true,
      'ownedLicense:expire': true,
      'ownedLicense:renew': true,
      'heldLicense:assign': true,
      'voucher:redeem': true
    };
    var columns = [{
      name: 'action',
      label: 'Action',
      filter: true,
      sort: true,
      render: function render(_ref3) {
        var value = _ref3.value;
        return _Log.ACTION_MAP[value].displayText;
      },
      filterSettings: {
        type: 'selectbox',
        field: 'action',
        options: Object.keys(actionWhiteList).map(function (k) {
          return {
            value: k,
            label: _Log.ACTION_MAP[k].displayText
          };
        })
      }
    }, {
      name: 'licensee',
      label: 'Username',
      filter: true,
      sort: true,
      render: function render(_ref4) {
        var value = _ref4.value;
        if (!value) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "This user or their license may have since been archived or deleted"
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null));
        }
        return value;
      }
    }, {
      name: 'fromGroup',
      label: 'Group',
      filter: true,
      sort: true,
      render: function render(_ref5) {
        var value = _ref5.value;
        return value || '-';
      }
    }, {
      name: 'voucher',
      label: 'Voucher',
      filter: true,
      sort: true,
      render: function render(_ref6) {
        var value = _ref6.value;
        return value || '-';
      }
    }, {
      name: 'createdAt',
      label: 'Action Time',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }];
    return {
      query: _individualsHistory["default"],
      orderBy: 'createdAt',
      isAscentOrder: false,
      columns: columns,
      graphqlVariables: {
        productId: selectedProduct.productId,
        actions: Object.keys(actionWhiteList)
      },
      rowKey: 'logId',
      render: function render(stuff) {
        var data = stuff.data,
          extraData = stuff.extraData,
          renderDefault = stuff.renderDefault;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderHistorySummary(extraData), renderDefault(data));
      }
    };
  }
  function getGroupCurrentProps() {
    var groupDef = Appdefs.pawn.groups.find(function (g) {
      return g.handle === showBy;
    });
    var groupTypeLabel = groupDef.label;
    var columns = [{
      name: 'group.label',
      label: groupTypeLabel,
      filter: true,
      sort: true
    }, {
      name: 'availableLicenses',
      label: 'Available Licenses',
      tooltip: 'This number does not include licenses that could be automatically inherited from a different group',
      filter: true,
      sort: true
    }, {
      name: 'descendantRoles.anyRoleCount',
      label: 'Licenses In Use',
      tooltip: "This is the number of Active Licenses for all roles in this ".concat(groupTypeLabel),
      filter: true,
      sort: true
    }];
    var parentGroupHandle = Array.isArray(groupDef.parentGroups) && groupDef.parentGroups.length > 0 && groupDef.parentGroups[0];
    if (parentGroupHandle) {
      columns.splice(1, 0, {
        name: 'parentGroup.anyGroup.group.label',
        label: Appdefs.pawn.groups.find(function (g) {
          return g.handle === parentGroupHandle;
        }).label,
        filter: true,
        sort: true
      });
    }
    return {
      query: _groups["default"],
      columns: columns,
      graphqlVariables: {
        productId: selectedProduct.productId,
        groupType: showBy
      },
      rowKey: 'group.groupId'
    };
  }
  function getGroupHistoricalProps() {
    var groupDef = Appdefs.pawn.groups.find(function (g) {
      return g.handle === showBy;
    });
    var groupTypeLabel = groupDef.label;
    var columns = [{
      name: 'group.label',
      label: groupTypeLabel,
      filter: true,
      sort: true
    }, {
      name: 'additions',
      label: 'Additions',
      filter: false,
      sort: false
    }, {
      name: 'renewals',
      label: 'Renewals',
      filter: false,
      sort: false
    }];
    var parentGroupHandle = Array.isArray(groupDef.parentGroups) && groupDef.parentGroups.length > 0 && groupDef.parentGroups[0];
    if (parentGroupHandle) {
      columns.splice(1, 0, {
        name: 'parentGroup.anyGroup.group.label',
        label: Appdefs.pawn.groups.find(function (g) {
          return g.handle === parentGroupHandle;
        }).label,
        filter: true,
        sort: true
      });
    }
    return {
      columns: columns,
      query: _groupsHistory["default"],
      graphqlVariables: {
        productId: selectedProduct.productId,
        groupType: showBy
      },
      rowKey: 'group.groupId',
      render: function render(_ref7) {
        var data = _ref7.data,
          extraData = _ref7.extraData,
          renderDefault = _ref7.renderDefault;
        var allGroups = 'summary.anyGroupList' in extraData && Array.isArray(extraData['summary.anyGroupList']) ? extraData['summary.anyGroupList'] : [];
        var additions = 0;
        var expirations = 0;
        var renewals = 0;
        allGroups.forEach(function (g) {
          additions += g.additions;
          expirations += g.expirations;
          renewals += g.renewals;
        });
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderHistorySummary({
          additions: additions,
          expirations: expirations,
          renewals: renewals
        }), renderDefault(data));
      }
    };
  }

  // common props
  var tableProps = {
    showDoubleScrollbar: true,
    isStickyHeader: true
  };
  if (showBy === 'individual') {
    tableProps = _objectSpread(_objectSpread({}, tableProps), isHistorical ? getIndividualHistoricalTableProps() : getIndividualCurrentTableProps());
  } else {
    tableProps = _objectSpread(_objectSpread({}, tableProps), isHistorical ? getGroupHistoricalProps() : getGroupCurrentProps());
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderOptions(), /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], _extends({}, tableProps, {
    key: showBy + isHistorical
  })));
}